
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Previewer from 'vux/src/components/previewer/index.vue'

import Swiper from 'swiper'
import mapUtil from '@/javascript/mapUtil'
import payPublic from '@/javascript/payPublic'
import videoBox from '@/components/public-components/videoStart/index.vue'
import EsQuery from '@/javascript/esQuery'
import { formatDate } from "@/javascript/formatDate"
import axios from 'axios'
import util from '@/javascript/util'


import mapList from '@/components/public-components/mapList/index.vue'
import goBack from '@/components/public-components/goBack/index.vue'
import Footer from "@/components/lyx-components/lyx-footer/index"

export default {
name: 'hotelDetails',
components: {
Tab,
TabItem,
Previewer,
mapList,
goBack,
Footer,
videoBox
},
data () {
return {
isWeixin: util.isWeiXin(),
showMapList: false,
minHeight: 0,
today: '',
nowTime: '',
dateRange: '',
spotList: [],
foodList: [],
hotelList: [],

bookMask: false,
hotelEntity: {},
shangjia: [],
imageList: [],
noShow: false, //暂时不显示
businessEntity: {},
contactEntity: {},
currentTitle: '',
curLng: '',
curLat: '',
videoList: [],
showList: false,
hasVideo: false,
hasImages: true,
videoShow: false, // 显示播放视频
videoUrl: '', // 播放视频链接
videoUrls: [],
typeList: [],
styleDetails: {},
show: false,
coverOpacity: false,
initDate: {},
checkIn: '',
currentPage: 1,
curNear: 0,
nearList: [],
positionData: '',
serveList: [],
picLength: [],
showPic: false,
descriptionLength: '',
infiniteAll: true,
collectParams: {
catalog: this.XQSC_TYPE_CODE.JD, //类别
picUrl: '', //图片URL
principalId: '', //被收藏对象id
serviceType: this.SERVICE_TYPE.JD, //浏览信息所属的服务类型
summary: '', //简介  (this.collectParams.summary == null) ? this.collectParams.subTitle : this.collectParams.summary
title: '', //浏览信息页面的标题
articleSite: '', //浏览页面信息的地址
}
}
},
created () {

},

mounted () {
this.minHeight = document.documentElement.clientHeight
this.init()

this.getList()

localStorage.setItem('njl-entity', this.$route.query.entity)
},
computed: {
videoShow2() {
return this.videoShow
}
},
methods: {

videoClick(url) {
this.videoShow = true
this.videoUrl = url
},
seeMore () {
this.infiniteAll = !this.infiniteAll;
},
init () {
this.$http.get(this.$route.query.url + this.$route.params.id).then(res => {
const data = res.data.data
this.hotelEntity = data[this.$route.query.entity]

data.fileList.image.all.materials.forEach(item => {
if (item.fileUrl.indexOf('\\') != -1) {
item.fileUrl = item.fileUrl.replaceAll("\\", "/\/")
}
this.$set(item, 'src', this.PIC_BASE_URL + item.fileUrl);
console.log(this.PIC_BASE_URL,'this.PIC_BASE_URLthis.PIC_BASE_URL');
})
this.picLength = data.fileList.image.all.materials
console.log(data.fileList.video.all.materials,'data.fileList.video.all.materials');
this.videoList = data.fileList.video.all.materials

this.descriptionLength = this.hotelEntity.content.length;
this.businessEntity = data.businessEntity
this.contactEntity = data.contactEntity

}).then(() => {
const _this = this
document.title = _this.hotelEntity.title
_this.$nextTick(() => {
new Swiper('.reserve-swiper', {
onSlideChangeStart: function (swiper) {
_this.currentPage = swiper.activeIndex + 1
}
})
})

if (this.imageList.length == 0) {
this.hasVideo = true
}
this.currentTitle = this.hotelEntity.title
this.curLng = this.hotelEntity.longitude
this.curLat = this.hotelEntity.latitude


})
},


closePic (arg) {
this.imageList = []
this.showPic = false
},

showViewer (item) {
const _this = this
_this.showPic = true
if (item) {
_this.imageList = item.commodityImages
setTimeout(function () {
_this.$refs.previewer.show(0)
}, 200)
} else {
_this.imageList = _this.picLength
setTimeout(function () {
_this.$refs.previewer.show(_this.currentPage - 1)
}, 200)
}
},
callPhone () {
if (this.businessEntity && this.businessEntity.phone != "暂无" && this.businessEntity.phone) {
payPublic.callPhone(this.businessEntity.phone)
} else {
payPublic.showPrompt(`暂无电话`)
}
},
callBook () {
if (this.hotelEntity.bookingLink && this.hotelEntity.bookingLink != "暂无") {
window.open(this.hotelEntity.bookingLink)
} else {
alert("暂时无法预定")
}
},
gpsJump (item) {
/**
* 定位
*/
mapUtil.locate((data) => {
window.location.href = 'https://map.qq.com/nav/drive#routes/page?eword=' + item.title + '&noback=&referer=groupActivity_myapp&ch=mc_h5marker&start=' + data.position.lng + ',' + data.position.lat + '&dest=' + item.longitude + ',' + item.latitude + '&sword=我的位置'
}, (data) => {
if (data == undefined) {
this.$notify({
title: '警告',
message: '定位失败，请开启定位权限',
type: 'warning'
});
data = {
location: {
position: {
lng: 101.026748,
lat: 36.872229
}
}
}
}
window.location.href = 'https://map.qq.com/nav/drive#routes/page?eword=' + item.title + '&noback=&referer=groupActivity_myapp&ch=mc_h5marker&start=' + data.position.lng + ',' + data.position.lat + '&dest=' + item.longitude + ',' + item.latitude + '&sword=我的位置'
})

},


getList () {
const _this = this
const querystring = require('querystring')


const allXcEsQuery = new EsQuery()
allXcEsQuery
allXcEsQuery.addString("category", _this.XXCJ_TYPE_CODE.CY, allXcEsQuery.and, false)
.addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, allXcEsQuery.and, false)
.addPage(0, 10)
const allXcEsJsonQuery = JSON.stringify(allXcEsQuery.getArray())
_this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: _this.INDEX_NAME_TYPE.periphery,
esJsonQuery: allXcEsJsonQuery
})).then(res => {
let data = res.data.data
_this.shangjia = data
_this.$nextTick(() => {
new Swiper('.the-recommend-swiper', {
slidesPerView: 'auto',
spaceBetween: 20,
initialSlide: 0,
})
})
})
},

}
}
